var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66521 6.22792L1.77913 0.309834C1.68245 0.211658 1.56743 0.133734 1.44071 0.0805564C1.31398 0.0273787 1.17805 0 1.04077 0C0.903483 0 0.767556 0.0273787 0.64083 0.0805564C0.514103 0.133734 0.399084 0.211658 0.302408 0.309834C0.108717 0.506087 0 0.771565 0 1.04829C0 1.32501 0.108717 1.59049 0.302408 1.78674L5.45013 7.02399L0.302408 12.2089C0.108717 12.4051 0 12.6706 0 12.9473C0 13.224 0.108717 13.4895 0.302408 13.6858C0.398722 13.7847 0.513578 13.8635 0.640322 13.9174C0.767065 13.9714 0.903176 13.9994 1.04077 14C1.17836 13.9994 1.31447 13.9714 1.44121 13.9174C1.56796 13.8635 1.68281 13.7847 1.77913 13.6858L7.66521 7.76768C7.77077 7.66959 7.85501 7.55055 7.91263 7.41804C7.97025 7.28554 8 7.14245 8 6.9978C8 6.85315 7.97025 6.71006 7.91263 6.57756C7.85501 6.44506 7.77077 6.32601 7.66521 6.22792Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.1df3c233748057729da7180b8d247f34.svg";
export { ForwardRef as ReactComponent };